import permissions from "../constants/permissions";
import CollectionsModuleLayout from "@/views/Pages/CollectionsModule/CollectionsModuleLayout.vue";
import CollectionsModuleMenu from "@/views/Pages/CollectionsModule/CollectionsModuleMenu.vue";

// import middleware
import authenticated from "@/middleware/authenticated";
import authorized from "@/middleware/authorized";

const CollectionsPage = () =>
  import("@/views/Pages/CollectionsModule/CollectionsPage.vue");

const ListPaymentCollectionPage = () =>
  import("@/views/Pages/CollectionsModule/PropertiesCollectionPaymentManagement/ListPropertiesPaymentPage.vue");

const ListPropertyCollectionPage = () =>
  import("@/views/Pages/CollectionsModule/PropertyCollectionManagement/ListPropertyPage.vue");

let paymentCollectionManagementPages = {
  path: "properties-collection-payments",
  components: {
    default: CollectionsModuleLayout,
    SidebarSecondLevelMenu: CollectionsModuleMenu,
  },
  children: [
    {
      path: "",
      name: "List PropertiesCollectionsPayments",
      components: { default: ListPaymentCollectionPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_PROPERTIES_PAYMENTS,
        hasLevel2: true,
      },
    },
  ],
};

let PropertyCollectionManagementPages = {
  path: "properties-collections",
  components: {
    default: CollectionsModuleLayout,
    SidebarSecondLevelMenu: CollectionsModuleMenu,
  },
  children: [
    {
      path: "",
      name: "List PropertyCollections",
      components: { default: ListPropertyCollectionPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_PROPERTIES_COLLECTIONS,
      },
    },
  ],
};

const CollectionsModuleRoutes = [
  {
    path: "",
    components: {
      default: CollectionsModuleLayout,
      SidebarSecondLevelMenu: CollectionsModuleMenu,
    },
    children: [
      {
        path: "",
        name: "Collections Page",
        components: { default: CollectionsPage },
        meta: {
          middleware: authenticated,
          hasLevel2: true,
        },
      },
    ],
  },
  paymentCollectionManagementPages,
  PropertyCollectionManagementPages,
];

export default CollectionsModuleRoutes;
